export default __webpack_public_path__ + "static/char-s-09-cht-d50afd364f8388d888577c004b2185f0.png";